import { useGetNodeQuery } from '@src/components/hierarchies/Hierarchy.generated';
import useTransformEditNodeData from '@src/components/hierarchies/hooks/useTransformEditNodeData';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext, useMemo } from 'react';

export default function useFetchModel({ cgtModelId }: { cgtModelId: string }) {
    const transformEditNodeData = useTransformEditNodeData();
    const { prototype, cgtSettings } = useContext(SettingsContext);

    const {
        data,
        loading: loadingModelNode,
        refetch: refetchModelNode,
    } = useGetNodeQuery({
        variables: {
            hierarchiesId:
                prototype?.hierarchies?.model || cgtSettings?.hierarchies.cGTModelHierarchyId,
            nodeFilter: {
                ids: [cgtModelId],
            },
        },
        fetchPolicy: 'network-only',
    });

    const modelNode = useMemo(() => transformEditNodeData(data ?? {}), [data]);

    return {
        modelNode,
        loadingModelNode,
        refetchModelNode,
    };
}
